
import { Vue } from "vue-class-component"; // 基本需要
import { dispatchGetCustomTest } from "@/store/task/actions";
import { store } from "@/store";

export default class Custom01 extends Vue {
  public text = "";
  public mounted() {
    dispatchGetCustomTest(store).then((res) => {
      if (res) {
        this.text = res;
      }
    });
  }
}
